import { render, staticRenderFns } from "./AdminTester.vue?vue&type=template&id=032b3c20&scoped=true&"
import script from "./AdminTester.vue?vue&type=script&lang=js&"
export * from "./AdminTester.vue?vue&type=script&lang=js&"
import style0 from "./AdminTester.vue?vue&type=style&index=0&id=032b3c20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032b3c20",
  null
  
)

export default component.exports